import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import StageGoal from './stage-goal-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <StageGoal {...validProps} />;
}

SvgComponent.iconName = 'stage-goal';

export const StageGoalIcon = svgIconWrapper(SvgComponent);
